/* eslint-disable */
export default {
  header: "Contatta l'assistenza",
  toggleTitle: '1. Attiva la modalità di tracciamento errori',
  toggleDescription:
    "Questo ci aiuterà a individuare i tuoi problemi, ma potrebbe influire leggermente sulle prestazioni dell'app.",
  downloadTitle:
    '2. Scarica il registro errori dopo aver replicato il problema.',
  downloadButton: 'Scarica',
  downloadDisabledTitle:
    'Attiva la modalità di tracciamento errori prima di poter scaricare il registro errori.',
  sendTitle: '3. Invia il registro al team di supporto',
  createSupportTicket: 'Crea un ticket di supporto',
  sendDescription:
    ' per metterti in contatto con il nostro team di assistenza. Quindi invia il registro al team di supporto per la risoluzione dei problemi.',
  privacyNotice:
    'Scaricando e inviandoci il registro, accetti che RingCentral possa accedere a determinate informazioni del registro a fini di risoluzione dei problemi e gestione degli errori. Per ulteriori informazioni su come RingCentral tratta i dati personali, consulta le nostre ',
  privacyNoticeLink: "Condizioni d'uso",
  and: ' e ',
  privacyNoticeEnd: 'Informativa sulla privacy.',
  needLeavePage:
    'Puoi abbandonare questa pagina mentre il tracciamento degli errori è in esecuzione. Dopo aver ripetuto il problema, torna a questa pagina e scarica i file di registro.',
  downloading: 'Download in corso',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
